import React from "react";
import { TrainingStatus } from "../../../services/formacion/formacion.types";
import { TRAINING_STATUS_LABELS } from "../../../utils/formacion/training-status";
import styles from "./TrainingStatusChip.module.scss";

interface Props {
  status: TrainingStatus;
}

const STATUS_CLASS: Record<TrainingStatus, string> = {
  SCHEDULED: styles.scheduled,
  LIVE: styles.live,
  COMPLETED: styles.completed,
};

const TrainingStatusChip: React.FC<Props> = ({ status }) => (
  <span className={`${styles.chip} ${STATUS_CLASS[status]}`}>
    {status === "LIVE" && <span className={styles.liveDot} />}
    {TRAINING_STATUS_LABELS[status]}
  </span>
);

export default TrainingStatusChip;
